query CampaignSections($clientId: ID!) {
    campaignSections(clientId: $clientId) {
        _id
        name
    }
}
